export default __webpack_public_path__ + "static/media/486966792e7340235c471a83e5f081281602465058680.1fbefda2.webp";